export default "__VITE_ASSET__DQm$n1pL__"